import React from 'react';
import { IconProps } from '.';

const SvgCircleCreditCard = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M6.25 7.25h11.5v9.5H6.25v-9.5Zm1.5 5v3h8.5v-3h-8.5Zm0-2.5h8.5v-1h-8.5v1Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        fillRule='evenodd'
        d='M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11Zm0-1.5a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgCircleCreditCard;
